export default "__VITE_ASSET__CtMTXzH___"